module.exports = __webpack_public_path__ + "static/29-386d2c1ebaf40d61a2526c2ff5f8094d.png";